import React, { FC, useMemo } from "react";
import { useNavigate } from "react-router";
import notFoundIcon from "../../assets/notFoundIcon.svg";
import somethingWrongIcon from "../../assets/somethingWrongIcon.svg";
import refreshPageIcon from "../../assets/refreshPageIcon.svg";
import arrowRightIcon from "../../assets/arrowRight.svg";
import discordIcon from "../../assets/discord.svg";
import twitterIcon from "../../assets/twitter.svg";
import { FaMediumM as MediumIcon } from "react-icons/fa";

import { HOME } from "../../common/constants/routes.constants";

import "./NotFound.scss";

const NotFound: FC<{ notFound: boolean; rpcError?: boolean }> = ({
  notFound,
  rpcError,
}) => {
  const navigate = useNavigate();

  const handlePageError = () => {
    if (notFound) {
      navigate(HOME);
    } else {
      window.location.reload();
    }
  };

  const renderErrorMessage = useMemo(() => {
    return notFound
      ? "Page does not exist or is unavailable."
      : rpcError
      ? "Problem with RPC, try with another one from nav bar"
      : "Something went wrong";
  }, []);

  return (
    <div className="not-found">
      <img
        className="not-found__icon"
        src={notFound ? notFoundIcon : somethingWrongIcon}
      />
      <h2 className="not-found__label">Ooops! </h2>
      <p className="not-found__description">{renderErrorMessage}</p>
      {!notFound && (
        <p className="not-found__description">
          Try refreshing the page, or try again later.
        </p>
      )}

      <button className="not-found__button" onClick={handlePageError}>
        {notFound ? "Go back to Homepage" : "Refresh page"}
        <img src={notFound ? arrowRightIcon : refreshPageIcon} />
      </button>
      <div className="not-found__socials">
        <a
          href={"https://discord.com/invite/uniquevcs"}
          target={"_blank"}
          rel="noreferrer"
        >
          <img src={discordIcon} alt="Discord link" />
        </a>
        <a
          href={"https://twitter.com/uniquevcs"}
          target={"_blank"}
          rel="noreferrer"
        >
          <img src={twitterIcon} alt="Twitter link" />
        </a>
        <a
          href={"https://uniquevcs.medium.com/"}
          target={"_blank"}
          rel="noreferrer"
        >
          <MediumIcon className="not-found__medium" />
        </a>
      </div>
    </div>
  );
};

export default NotFound;
